// 账号详情统计
import myRequest from '@/services/myRequest';

export async function queryAccountInfoStats(params) {
  return myRequest('get', '/dataStats/accountInfoStats', params);
}
